import type {Role} from 'next-auth';

type DeprecatedRole = Role | 'regularUser';
export type UserPrivilegeLevelRole = {
  isAdmin: boolean;
  isReviewer: boolean;
  isAppOwner: boolean;
  isAccessUser: boolean;
  isCampaignOwner: boolean;
  role: DeprecatedRole | null;
  isLinxConfigurationAdmin: boolean;
  isReadOnlyAdmin: boolean;
};

const PRIVILEGE_LEVEL: Array<DeprecatedRole> = [
  `admin`,
  `app_owner`,
  `campaign_owner`,
  `read_only_admin`,
  `access_user`,
  `reviewer`,
  `regularUser`,
  `linx_configuration_admin`,
];
export const getHighestPrivilegeRole = (userRoles: Array<string> | undefined): UserPrivilegeLevelRole => {
  const highestPrivilegeRole = (): DeprecatedRole | null => {
    if (!userRoles) {
      return null;
    }
    const roleIndex = PRIVILEGE_LEVEL.findIndex(role => userRoles.includes(role));
    const role = roleIndex !== -1 ? PRIVILEGE_LEVEL[roleIndex] : null;
    return role;
  };
  const role = highestPrivilegeRole();
  return {
    role,
    isAdmin: role === `admin`,
    isReviewer: role === `reviewer`,
    isAppOwner: role === `app_owner`,
    isCampaignOwner: role === `campaign_owner`,
    isAccessUser: role === `access_user`,
    isLinxConfigurationAdmin: role === `linx_configuration_admin`,
    isReadOnlyAdmin: role === `read_only_admin`,
  };
};
